import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-secure-phrase',
  templateUrl: 'dialog-secure-phrase.component.html',
})
export class DialogSecurePhraseComponent {
  form: FormGroup;
  fieldValue = '';

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DialogSecurePhraseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.buildForm();
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  onConfirmClick(): void {
    if (
      !this.form.valid ||
      !this.form.value.fieldValue.trim() ||
      this.data.securePhrase !== this.form.value.fieldValue
    ) {
      return;
    }

    this.dialogRef.close(true);
  }

  private buildForm() {
    this.form = this.fb.group({
      fieldValue: [null, Validators.required],
    });
  }
}
